import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  ActivatedRouteSnapshot,
  ActivationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import {
  NavController,
  IonRouterOutlet,
  IonMenu,
  IonContent,
  IonSplitPane,
  IonButton,
  IonIcon,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  add,
  bookOutline,
  flashOutline,
  homeOutline,
  peopleOutline,
  settingsOutline,
  sparkles,
} from 'ionicons/icons';
import { StoryService } from 'src/app/features/stories/story.service';
import { AuthService } from 'src/app/features/auth/auth.service';
import { injectParam } from 'src/app/utils/injectionsUtils/activatedRouteUtils';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { ChatsListComponent } from './components/chats-list/chats-list.component';
import { ChatPage } from 'src/app/features/chat/pages/chat/chat.page';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';

function findChatPageRecursice(root: ActivatedRouteSnapshot) {
  if (root.component === ChatPage) return root;
  else if (root.firstChild) return findChatPageRecursice(root.firstChild);
  else return undefined;
}

@Component({
  selector: 're-story',
  templateUrl: './story.page.html',
  styleUrls: ['./story.page.scss'],
  providers: [
    {
      provide: StoryService,
      useFactory: () => StoryService.factory(Number(injectParam('story'))),
    },
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    IonRouterOutlet,
    IonMenu,
    IonContent,
    IonSplitPane,
    IonButton,
    IonIcon,
    ChatsListComponent,
    ...TRANSLATE_IMPORTS,
  ],
})
export class StoryPage {
  navController = inject(NavController);
  story = inject(StoryService);
  router = inject(Router);
  profile = inject(AuthService).profileSignal;

  constructor() {
    addIcons({
      add,
      bookOutline,
      flashOutline,
      homeOutline,
      peopleOutline,
      settingsOutline,
      sparkles,
    });
  }

  showCreateChat = computed(
    () => this.profile()?.id === this.story.data()?.creator,
  );

  activeChat = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof ActivationEnd),
      map((event) => {
        return findChatPageRecursice((event as ActivationEnd).snapshot.root);
      }),
      map((snap) => {
        return snap
          ? snap.paramMap.get('chat')
            ? Number(snap.paramMap.get('chat'))
            : undefined
          : undefined;
      }),
    ),
  );

  activeChatData = computed(
    () =>
      this.story.chats().find((chat) => chat.id === this.activeChat()) ??
      undefined,
  );
}
